import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed, watch } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';
import i18n from '@/lang/i18n';
import VehicleAutoComplete from '@/components/AutoCompletes/VehicleAutoComplete.vue';
import DeviceIdAutoComplete from '@/components/AutoCompletes/DeviceIdAutoComplete.vue';
import SingleOperationOfficeAutoComplete from '@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue';
import RemoveDeviceTable from '@/components/Firmware/BulkUpdate/RemoveDeviceTable.vue';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getVehicleResponse from '@/types/responses/getVehicle';
import getPaginatedDevicesRequest from '@/types/requests/getPaginatedDevices'
import getDeviceResponse from '@/types/responses/getDevice';
import FirmwareRemoveDeviceType from '@/types/FirmwareRemoveDeviceType';
import getDevice from '@/types/responses/getDevice';


export default /*@__PURE__*/_defineComponent({
  __name: 'RemoveDeviceSearch',
  props: {
    modelValue: {},
    removeDevices: {},
    errorMessages: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props

watch(
  () => props.removeDevices,
  () => {
    if (props.removeDevices) {
      removedDeviceList.value = props.removeDevices.reduce<FirmwareRemoveDeviceType[]>((acc, device) => {
          const newDevice: FirmwareRemoveDeviceType = {
            ...device,
            isChecked: false
          }
          acc.push(newDevice)

        return acc;
      }, []);
    }
  }
)

const removedDeviceIds = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
})

const selectedOperationOffice = ref<getOperationOffice>()
const selectedDevice = ref<getDeviceResponse | undefined>()
const selectedVehicle = ref<getVehicleResponse | undefined>()
const deviceList = ref<FirmwareRemoveDeviceType[]>([])
const removedDeviceList = ref<FirmwareRemoveDeviceType[]>([])
const isSearched = ref(true)
const currentPage = ref<number>(1)
const totalPage = ref<number>(0)

function searchDeviceHandler() {
  currentPage.value = 1
  searchDevice()
}

function searchDevice() {
  isSearched.value = false
  const params = {
    page: currentPage.value
  } as getPaginatedDevicesRequest

  if (selectedOperationOffice.value) {
    const operataionOfficeId = selectedOperationOffice.value.id;
    params.operation_office_id = operataionOfficeId
  }

  if (selectedDevice.value) {
    const deviceId = selectedDevice.value.device_id;
    params.device_id = deviceId
  }

  if (selectedVehicle.value) {
    const vehicleId = selectedVehicle.value.id;
    params.vehicle_id = vehicleId
  }

  Api().getPaginatedDevices(params).then((data) => {
    deviceList.value = data.devices.reduce<FirmwareRemoveDeviceType[]>((acc, device) => {
      if (!removedDeviceIds.value.includes(device.id)) {
        const newDevice: FirmwareRemoveDeviceType = {
          ...device,
          isChecked: false
        }
        acc.push(newDevice)
      }

      return acc;
    }, []);
    currentPage.value = data.current_page
    totalPage.value = data.total_page
    isSearched.value = true
  }).catch((error) => {
    const res = error.response
    console.log(res)
  })
}

function moveToSearchedDeviceList() {
  const movedList = [] as FirmwareRemoveDeviceType[]
  removedDeviceList.value?.forEach((device) => {
    if (device.isChecked) {
      device.isChecked = false
      deviceList.value.push(device)
    } else {
      movedList.push(device)
    }
  })
  removedDeviceList.value = movedList
  setRemovedDeviceIds()
}
function moveToRemovedDeviceList() {
  const movedList = [] as FirmwareRemoveDeviceType[]
  deviceList.value?.forEach((device) => {
    if (device.isChecked) {
      device.isChecked = false
      removedDeviceList.value.push(device)
    } else {
      movedList.push(device)
    }
  })
  setRemovedDeviceIds()
  deviceList.value = movedList
}

function setRemovedDeviceIds() {
  removedDeviceIds.value = removedDeviceList.value.map((device) => {
    return device.id
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "fw-bold" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.firmwareBulkUpdate.removeDeviceSearch.name')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "d-flex align-items-center" }, {
          default: _withCtx(() => [
            _createVNode(SingleOperationOfficeAutoComplete, {
              modelValue: selectedOperationOffice.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((selectedOperationOffice).value = $event)),
                searchDeviceHandler
              ]
            }, null, 8, ["modelValue"]),
            _createVNode(DeviceIdAutoComplete, {
              class: "ml-4 mr-4",
              modelValue: selectedDevice.value,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((selectedDevice).value = $event)),
                searchDeviceHandler
              ],
              operationOffices: selectedOperationOffice.value ? [selectedOperationOffice.value]:[]
            }, null, 8, ["modelValue", "operationOffices"]),
            _createVNode(VehicleAutoComplete, {
              modelValue: selectedVehicle.value,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((selectedVehicle).value = $event)),
                searchDeviceHandler
              ],
              operationOffices: selectedOperationOffice.value ? [selectedOperationOffice.value]:[],
              selectedDepartment: null
            }, null, 8, ["modelValue", "operationOffices"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "fw-bold" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.firmwareBulkUpdate.removeDeviceSearch.result')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(RemoveDeviceTable, {
              modelValue: deviceList.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((deviceList).value = $event)),
              isShowTable: isSearched.value
            }, null, 8, ["modelValue", "isShowTable"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "d-flex justify-content-end align-items-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_pagination, {
              modelValue: currentPage.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((currentPage).value = $event)),
              length: totalPage.value,
              "total-visible": 6,
              density: "compact",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (searchDevice()))
            }, null, 8, ["modelValue", "length"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_divider, { class: "my-4" }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "d-flex justify-content-center align-items-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              class: "mr-2",
              onClick: moveToSearchedDeviceList
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("▲", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              class: "ml-2",
              onClick: moveToRemovedDeviceList
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("▼", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "fw-bold" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.firmwareBulkUpdate.removeDeviceSearch.removeDevice')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(RemoveDeviceTable, {
              modelValue: removedDeviceList.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((removedDeviceList).value = $event)),
              isShowTable: true,
              errorMessages: props.errorMessages
            }, null, 8, ["modelValue", "errorMessages"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})